export default __webpack_public_path__ + "static/media/30t.a8c21464.jpg";